import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GuestModel } from '../models/guest.model';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class GuestService   extends BaseService<GuestModel>{

  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}api/Guest`);
  }
  
  getByDocNumber(docNumber: string, docType: string): Observable<GuestModel[]> {
    return this.http.get<GuestModel[]>(`${this.backUrl}/Query?filter=DocumentNumber eq '${docNumber}' and DocumentType eq '${docType}'`);
  }  

  saveGuests(model: GuestModel[]): Observable<any> {
    return this.http.post(`${this.backUrl}/SaveGuests`, model);
  }
}
